import { Locale } from '@ps-smart-cp/ppfw-client';

const onBalanceConfig = {
  onBalance: new Map([
    [Locale.ja, 'オンバランス'],
    [Locale.en, 'On Balance'],
  ]),
  offBalance: new Map([
    [Locale.ja, 'オフバランス'],
    [Locale.en, 'Off Balance'],
  ]),
};

export { onBalanceConfig };
